// extracted by mini-css-extract-plugin
export default {"container":"tl-z","blurb":"ul-z","links":"vl-z"};